// Simple Socket.IO client for React
import { useEffect, useRef } from 'react';
import  io from 'socket.io-client';

export function useSocket(url: string, onMessage: (event: string, data: any) => void) {
    const socketRef = useRef<ReturnType<typeof io> | null>(null);

    useEffect(() => {
        const socket = io(url, { transports: ['websocket'] });
        socketRef.current = socket;

        (socket as any).onAny((event: string, ...args: any[]) => {
            onMessage(event, args[0]);
        });

        return () => {
            socket.disconnect();
        };
    }, [url, onMessage]);

    return socketRef;
}
